module.exports = __webpack_public_path__ + "static/media/sampleWarehouseEmail.e70a746f.png";